import {
  PopoverTrigger,
  PopoverContent,
  Popover,
} from "@repo/ui/components/ui/popover";
import { cn } from "@repo/ui/lib/utils";
import Icon from "@repo/ui/components/ui/icon/icon";
import { useNotificationToggle } from "./notifications-icon";

export default function NotificationsPopover({
  className,
  counter,
  ...props
}: React.HTMLAttributes<HTMLElement> & {
  counter?: number;
}) {
  const toggleContext = useNotificationToggle();

  return (
    <Popover
      open={toggleContext?.isToggled}
      onOpenChange={toggleContext?.setIsToggled}
    >
      <PopoverTrigger>
        <div
          className={cn(
            "relative h-[46px] w-[46px] max-md:hidden pl-[11px] pt-2 items-center justify-center rounded-full cursor-pointer bg-primary-black dark:bg-primary-white *:stroke-primary-white dark:*:stroke-primary-black *:fill-primary-black dark:*:fill-primary-white text-[18px]",
            className,
          )}
          {...props}
        >
          {!!counter && (
            <div className="rounded-full w-5 h-5 text-sm bg-primary-magenta absolute top-[-5px] right-[0px]">
              {counter}
            </div>
          )}
          <Icon icon="Bell" />
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-[400px] max-h-[80vh] dark:bg-secondary-black border-none p-10 text-primary-white overflow-y-scroll">
        {props.children}
      </PopoverContent>
    </Popover>
  );
}
